import { useEffect, useState } from 'react'
import styles from './PlatformCardPage.module.css'
import Navbar from '../../components/Navbar/Navbar'
import iconEdit from '../../assets/icons/iconEdit.svg'
import PlatformCardShortInformation from '../../components/PlatformCardShortInformation/PlatformCardShortInformation'
import PlatformCardFilesBlock from '../../components/PlatformCardFilesBlock/PlatformCardFilesBlock'
import ReviewsForCards from '../../components/ReviewsForCards/ReviewsForCards'
import PlatformCardBooking from '../../components/PlatformCardBooking/PlatformCardBooking'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import PATH from '../../navigation/path'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import {
  createPlatformComments,
  getCurrentPlaces,
  getPlatformComments,
} from '../../redux/actions/placesAction'
import Loader from '../../components/UI/Loader/Loader'
import noImage from '../../assets/img/no-image.jpg'
import HeaderForCard from '../../components/HeaderForCard/HeaderForCard'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import NewSlider from '../NewSlider/NewSlider'
import { useToast } from '../../context/ToastContext'

const PlatformCardPage = () => {
  const [visiblePopup, setVisiblePopup] = useState(false)
  const [commentFile, setCommentFile] = useState<any>([])
  const { showSuccess, showError } = useToast()
  const navigate = useNavigate()

  let { userRole, user } = useAppSelector((state) => state.auth)
  let { isLoading, currentPlace, placesComments, isLoadingComments } = useAppSelector(
    (state) => state.places,
  )

  const { token } = useAppSelector((state) => state.auth)

  const { platformId } = useParams<{ platformId: string }>()

  const dispatch = useAppDispatch()
  const location = useLocation()

  const dummyData = (imagesArr: string[]) => {
    return imagesArr.map((image, index) => {
      return { id: index, src: `${process.env.REACT_APP_BASE_URL_IMAGES}${image}` }
    })
  }

  const imagesFull = dummyData(currentPlace.images)

  const postNewCommentHandler = async (text: string) => {
    const formData = new FormData()

    if (commentFile) {
      for (let i = 0; i < commentFile.length; i++) {
        formData.append('file', commentFile[i])
      }
    }

    formData.append('placeId', String(currentPlace.id))
    formData.append('text', text)

    const resultAction = await dispatch(
      createPlatformComments({
        formData,
      }),
    )

    if (createPlatformComments.rejected.match(resultAction)) {
      showError('Произошла ошибка при создании комментария')
    } else {
      showSuccess('Комментарий успешно оставлен')
      await dispatch(getPlatformComments({ placeId: platformId }))
      setCommentFile([])
    }
  }

  const onRedirectBack = () => {
    navigate(-1)
  }

  const onRedirectToEditCardPage = () => {
    navigate(`${PATH.editPlatformCardPage}${platformId}`)
  }

  const foundObject = currentPlace.company.employees.find((item) => item.id === user.employee?.id)

  useEffect(() => {
    dispatch(getCurrentPlaces({ placeId: platformId, token }))
  }, [platformId, dispatch])

  useEffect(() => {
    if (userRole !== 'directorAgent' && userRole !== 'employeeAgent') {
      dispatch(getPlatformComments({ placeId: platformId }))
    }
  }, [platformId, dispatch])

  if (isLoading) {
    return <Loader />
  }

  return (
    <div className={styles.platformCard}>
      <Navbar />
      <HeaderForCard onRedirectHandler={onRedirectBack} title={currentPlace.name} />
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Основная информация</h2>
          {(userRole === 'superAdmin' ||
            userRole === 'admin' ||
            (userRole === 'directorPlace' && foundObject)) && (
            <CustomButton
              iconSrc={iconEdit}
              className={styles.btn}
              title={''}
              onClick={onRedirectToEditCardPage}
            />
          )}
        </div>

        <div className={styles.wrapper}>
          <div>
            {imagesFull.length !== 0 ? (
              <div className={styles.slider} onClick={() => setVisiblePopup(true)}>
                <NewSlider slides={imagesFull} />
              </div>
            ) : (
              <div className={styles.slider}>
                <img className={styles.noImage} src={noImage} alt='noImage' />
              </div>
            )}
            <div className={styles.content}>
              <div className={styles.leftBlock}>
                <PlatformCardShortInformation platformData={currentPlace} />
                {currentPlace.files.length !== 0 && (
                  <PlatformCardFilesBlock platformData={currentPlace} />
                )}
              </div>
            </div>
          </div>
          <div className={styles.rightBlock}>
            {(userRole === 'superAdmin' ||
              userRole === 'admin' ||
              userRole === 'directorAgent' ||
              userRole === 'employeeAgent') && (
              <PlatformCardBooking
                bookingData={
                  location?.state?.bookingData ? location?.state?.bookingData : currentPlace
                }
                platformData={currentPlace}
                platformCity={currentPlace.city}
              />
            )}
            {isLoadingComments ? (
              <Loader />
            ) : (
              <>
                {userRole !== 'directorAgent' && userRole !== 'employeeAgent' && (
                  <ReviewsForCards
                    employees={currentPlace.company.employees}
                    comments={placesComments}
                    postNewCommentHandler={postNewCommentHandler}
                    setCommentFile={setCommentFile}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default PlatformCardPage
